import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };
            this.loading = true;
            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址
                        if (this.SchoolConsigneeList[i].IsDefault == 1) {
                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id
                        }
                    }
                });
            });
        },
        //新增会销下单
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/MeetOrder/MeetOrderAddEx", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '下单成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false

                });
            });
        },
        //修改订单
        getUpdateOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/MeetOrder/MeetOrderUpdateEx", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });

                    this.AddDialogVisible = false
                });
            });
        },
        // 查看/修改
        getList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: this.showData.OrderId
            };
            this.loading = true;
            $http.get("api/MeetOrder/GetMeetOrderByIdEx", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form = util.filterAndSetData(this.form, Data) //过滤数据
                    this.form.OrderId = Data.OrderId
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress, //收货地址
                        this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话
                    // 判断是否下过单
                    if (Data.GiftList.length == 3) {
                        this.isOpen = true
                    } else {
                        this.isOpen = false
                    }
                    this.payList = Data.PayList
                });
            });
        },
        getSchoolList(agentId, schoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                AgentId: agentId,
                SchoolId: schoolId
            };
            this.loading = true;
            $http.get("api/Common/GetSchoolList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form.SchoolId = Data[0].Id
                    this.getSchoolConsigneeList(this.form.SchoolId)
                    this.getCheckMeetOrder(this.form.SchoolId) //判断是否下过会销订单
                });
            });
        },
        //获取代理商列表
        getAgentList(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                agentLevel: 2,
                AgentId: agentId,
                PolicyType: 4
            };

            this.loading = true;
            $http.get("api/Common/GetAgentList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.agent = Data[0].Customer + '   ' + Data[0].Address + '   ' + Data[0].AgentTel
                });
            });
        },
        // 判断是否下过会销订单
        getCheckMeetOrder(schoolId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: schoolId,
                OrderId: this.showData.OrderId
            };
            this.loading = true;
            $http.get("api/MeetOrder/CheckMeetOrder", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    // Data.ExistMeetOrder==0 为未开班
                    if (Data.ExistMeetOrder == 0) {
                        this.isOpen = true
                    } else {
                        this.isOpen = false
                    }
                    this.form.ExistMeetOrder = Data.ExistMeetOrder
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrder/addSellingOrder/services.js